
export function email(mail) {
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
        return (true);
    }
    
    return (false);
}



export function phone10Digit(inputtxt) {
    var phoneno = /^\d{10}$/;
    if (inputtxt.match(phoneno)) {
        return true;
    }
    else {
        return false;
    }
}



export function date_yyyy_mm_dd(date) {
    if(typeof date === 'string' &&
    date.length === 10 &&
    !isNaN(date.substr(0, 4)) &&
    !isNaN(date.substr(5, 2)) &&
    !isNaN(date.substr(8, 2)) &&
    date.charAt(4) === '-' &&
    date.charAt(7) === '-') {
        const month = parseInt(date.substr(5, 2));
        const day = parseInt(date.substr(8, 2));

        if(day > 0 && day < 32 &&
        month > 0 && month < 13)  {
            return true;
        }
    }

    return false;
}